<template>
    <div class="imageInput">
        <div id="file-input" class="file-input">
            <div v-if="imagePath">
                <img style="z-index: 1000;" v-bind:class="[isFullScreen ? 'fullscreen_image' : 'form-image']" :src="imagePath" @click="isFullScreen = !isFullScreen" />
            </div>
            <chill-icon v-if="!disabled && imagePath" @click="removeImage()" class="warning medium-icon" icon="icon_delete" style="margin-right: 10px;"/>
            <input v-if="!disabled" :id="'file-upload'+keyValue" type="file" @change="emitBase64Event($event)" accept="image/*" hidden />
            <label v-if="!disabled" :for="'file-upload'+keyValue" class="input-file-button">{{trans('choose_file')}}</label>
        </div>
    </div>
</template>

<script>

export default {
	name: "imageInput",
	props: ["imagePath", "keyValue", "disabled"],
	data() {
		return {
            isFullScreen: false
		}
	},
	methods: {
        removeImage(){
            this.$emit('change', this.keyValue, "")
        },
        emitBase64Event(event) {
            var input = event.target;
			var vm = this;
			if (input.files && input.files[0]) {
				var reader = new FileReader();
				reader.onload = e => {
                    vm.base64Resize(vm, this.keyValue, e.target.result)
                    //vm.$emit('change', this.keyValue, e.target.result)
				};
				reader.readAsDataURL(input.files[0]);
			}
        },
        base64Resize(vm, keyValue, sourceBase64) {

            // const _scale = scale;
            var img = document.createElement('img');
            img.setAttribute("src", sourceBase64);

            img.onload = () => {
                var canvas = document.createElement('canvas');
                // canvas.width = img.width * _scale;
                // canvas.height = img.height * _scale;

                canvas.width = 1600;
                canvas.height = 1200;


                var ctx = canvas.getContext("2d");
                // var cw = canvas.width;
                // var ch = canvas.height;
                var maxW = 1600;
                var maxH = 1200;

                var iw = img.width;
                var ih = img.height;
                var scl = Math.min((maxW / iw), (maxH / ih));
                var iwScaled = iw * scl;
                var ihScaled = ih * scl;
                canvas.width = iwScaled;
                canvas.height = ihScaled;
                ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
                const newBase64 = canvas.toDataURL("image/jpeg", scl);
                vm.$emit('change', keyValue, newBase64)
            }
        }
	}
};
</script>
<style scoped>
    input[type="file"] {
        width: 83px;
    }
    .text-file-upload {
        width: 100%;
        background-color: #1B608C;
        color: #FFFFFF;
        height: 28px;
        border-radius: 4px;
        border: none;
        margin-top: 8px;
        padding: 0px 6px;
    }
    .text-file-upload:hover {
        cursor: pointer;
    }
    .file-input {
        /* text-align: center; */
    }
    .form-image {
        object-fit: cover;
        border-radius: 5px;
        width: 110px;
        height: 110px;
        border-radius: 4px;;

    }
    .fullscreen_image {
        width: 100%;
        height: 100%;
        bottom: 0;
        left: 0;
        margin: auto;
        overflow: auto;
        position: fixed;
        right: 0;
        top: 0;
        -o-object-fit: contain;
        object-fit: contain;
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }
    .input-file-button {
        width: 100%;
        background-color: #1B608C;
        color: #FFFFFF;
        /* height: 58px; */
        border-radius: 28px;
        border: none;
        margin-top: 8px;
        /* margin-bottom: 50px; */
        padding: 3px 12px;
        font-size: 14px;
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
</style>